import { GradedUnit } from 'app/library/graded-unit/models/graded-unit.model';
import { Grade } from 'app/library/grading-scheme/models/grade.model';
import { User } from 'app/projects/user/src/lib/models/user';
import { IPartialGradeQuery } from '../interfaces/partial-grade.query.interface';

export class PartialGrade {
    static label_singular = 'partial-grade';
    static label_plural = 'partial-grades';

    static props_to_search = ['comment', 'user', ...User.props_to_search];

    id: string = null;
    comment: string = null;
    gradedUnitId: string = null;
    gradedUnit?: GradedUnit = null;
    participantId: string = null;
    user?: User = null;
    gradeId: string = null;
    grade?: Grade = null;
    status: 'published' | 'unpublished';

    constructor(query?: IPartialGradeQuery) {
        if (query) {
            if (query.id) {
                this.id = query.id.toString();
            }
            this.comment = query.comment;
            if (query.graded_unit && query.graded_unit.id) {
                this.gradedUnitId = query.graded_unit.id.toString();
            }
            if (query.participant && query.participant.id) {
                this.user = new User(query.participant);
            }
            if (query.grade && query.grade.id) {
                this.gradeId = query.grade.id.toString();
            }
            this.status = query.status;
        }
    }

    get userFullName(): string {
        return this.user ? this.user.fullName : '';
    }

    get gradeNumericValue(): number {
        return this.grade ? this.grade.numericValue : null;
    }

    get published(): boolean {
        return this.status === 'published';
    }
}
